import React from "react";
import History from "../../utilities/History";
import Landing from "./Landing";
import './instrumentDashboard.sass';


interface IIndexState {

}

export default class Index extends React.Component<{ location: any }, IIndexState > {
  private _mount = false;
  private _isReload = true;
  private _messages: string[];
  private _id = "";
  private _isValid: boolean = false;

  constructor(props: { location: any }) {
    super(props);
    this._mount = false;
    this.state = {
      
    };

    if (this.props.location.state && this.props.location.state.isReloadFirst !== undefined) {
      this._isReload = this.props.location.state.isReloadFirst;
      this._id = this.props.location.state.id;

      const state = { ...this.props.location.state };
      delete state.isReloadFirst;
      delete state.id;
      History.replace({ ...History.location, state });
    }
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
  }

  public render() {
    return (
      <div className="dashboard-layout-margin">
        <React.Fragment>
          <div className="w-100" style={{ background: "#F5F5F5" }}>
            <Landing />
          </div>
        </React.Fragment>
      </div>
    );
  }
}
